export const PHONES = [
  { key: 0, value: '', text: '' },
  { key: 1, value: 'FATHER_CELL', text: 'Father cell' },
  { key: 2, value: 'MOTHER_CELL', text: 'Mother cell' },
  { key: 3, value: 'PATIENT_CELL', text: 'Patient cell' },
  { key: 4, value: 'HOME', text: 'Home' },
  { key: 5, value: 'WORK', text: 'Work' },
  { key: 6, value: 'OTHER', text: 'Other' }
];

export const PROGRAM = [
  { key: 0, value: '', text: '' },
  { key: 1, value: '', text: 'Unspecified' },
  { key: 2, value: 'Adult Congenital Program', text: 'Adult Congenital Program' },
  { key: 3, value: 'Arthythmia/EP Program', text: 'Arthythmia/EP Program' },
  {
    key: 4,
    value: 'Biventricular Repair Program',
    text: 'Biventricular Repair Program'
  },
  { key: 5, value: 'Cardiac Clearance', text: 'Cardiac Clearance' },
  { key: 6, value: 'Cardiac Tumor Program', text: 'Cardiac Tumor Program' },
  { key: 7, value: 'Cardiomyopathy Program', text: 'Cardiomyopathy Program' },
  { key: 8, value: 'Cardiovascular Genetics', text: 'Cardiovascular Genetics' },
  {
    key: 9,
    value: 'Coronary Anomalies Program',
    text: 'Coronary Anomalies Program'
  },
  { key: 10, value: 'Fetal Cardiology Program', text: 'Fetal Cardiology Program' },
  { key: 11, value: 'Fontan at Boston Clinic', text: 'Fontan at Boston Clinic' },
  { key: 12, value: 'Heart Failure Program', text: 'Heart Failure Program' },
  // do not remove the space at the end, this is to accommodate provider side current value
  { key: 13, value: 'Heterotaxy Program ', text: 'Heterotaxy Program' },
  { key: 14, value: 'Kawasaki Program', text: 'Kawasaki Program' },
  {
    key: 15,
    value: 'Mid Aortic Syndrome Program',
    text: 'Mid Aortic Syndrome Program'
  },
  { key: 16, value: 'Other', text: 'Other' },
  {
    key: 17,
    value: 'Pulmonary Artery Reconstruction',
    text: 'Pulmonary Artery Reconstruction'
  },
  {
    key: 18,
    value: 'Pulmonary Hypertension Program',
    text: 'Pulmonary Hypertension Program'
  },
  {
    key: 19,
    value: 'Pulmonary Vein Stenosis Program',
    text: 'Pulmonary Vein Stenosis Program'
  },
  {
    key: 20,
    value: 'Single Ventricle Program',
    text: 'Single Ventricle Program'
  },
  { key: 21, value: 'Transplant Program', text: 'Transplant Program' },
  { key: 22, value: 'Valve Center', text: 'Valve Center' },
  { key: 23, value: 'Vascular Ring Program', text: 'Vascular Ring Program' },
  { key: 24, value: 'Williams Syndrome Program', text: 'Williams Syndrome Program' }
];

export const SURGEON = [
  { key: 1, value: '', text: '' },
  { key: 2, value: 'CH115643', text: 'BARD, CHRISTOPHER' },
  { key: 3, value: 'DELNIDO', text: 'DEL NIDO, PEDRO' },
  { key: 4, value: 'CH120481', text: 'EMANI, SITARAM' },
  { key: 5, value: 'CH126465', text: 'FEINS, ERIC' },
  { key: 6, value: 'CH098948', text: 'FYNN-THOMPSON, FRANCIS' },
  { key: 7, value: 'CH128043', text: 'HOGANSON, DAVID' },
  { key: 8, value: 'CH126182', text: 'KAZA, ADITYA' },
  { key: 9, value: 'CH188892', text: 'KWON, MICHAEL' },
  { key: 10, value: 'CH156333', text: 'QUINONEZ, LUIS' }
];

export const WHYCHOOSE = [
  { key: 0, value: '', text: '' },
  { key: 1, value: '', text: 'Unspecified' },
  { key: 2, value: 'establishedPatient', text: 'Established BCH Patient' },
  { key: 3, value: 'nationalRanking', text: 'National ranking or reputation' },
  {
    key: 4,
    value: 'recommendationByPCP',
    text: 'Recommendation by primary care clinician'
  },
  {
    key: 5,
    value: 'recommendationByCardiologist',
    text: 'Recommendation by cardiologist'
  },
  {
    key: 6,
    value: 'recommendationByOBGYN',
    text: 'Recommendation by obstetrician/maternal fetal medicine clinician'
  },
  { key: 7, value: 'familyRecommendation', text: 'Recommendation from family' },
  { key: 8, value: 'friendRecommendation', text: 'Recommendation from a friend' },
  {
    key: 9,
    value: 'socialMediaRecommendation',
    text: 'Recommendation from social media or patient support group'
  },
  {
    key: 10,
    value: '3rdParty',
    text: 'Recommendation from 3rd party (foundation/ organization/agency)'
  },
  {
    key: 11,
    value: 'digital marketing',
    text: 'Digital marketing or advertisement'
  }
];

export const getSurgeonName = (value) => {
  var obj = SURGEON.find((obj) => {
    return obj.value === value;
  });
  return obj !== undefined ? obj.text : '';
};

export const getSurgeonValue = (name) => {
  var obj = SURGEON.find((obj) => {
    return obj.text === name;
  });
  return obj !== undefined ? obj.value : '';
};

export const getWhyChooseText = (value) => {
  var obj = WHYCHOOSE.find((obj) => {
    return obj.value === value;
  });
  return obj !== undefined ? obj.text : '';
};

export const getWhyChooseValue = (text) => {
  var obj = WHYCHOOSE.find((obj) => {
    return obj.text === text;
  });
  return obj !== undefined ? obj.value : '';
};

export const getProgramText = (value) => {
  var obj = PROGRAM.find((obj) => {
    return obj.value === value;
  });
  return obj !== undefined ? obj.text : '';
};

export const getProgramValue = (text) => {
  var obj = PROGRAM.find((obj) => {
    return obj.text === text;
  });
  return obj !== undefined ? obj.value : '';
};

export const getPhoneTypeText = (value) => {
  var obj = PHONES.find((obj) => {
    return obj.value === value;
  });
  return obj !== undefined ? obj.text : '';
};

export const getPhoneTypeValue = (text) => {
  var obj = PHONES.find((obj) => {
    return obj.text === text;
  });
  return obj !== undefined ? obj.value : '';
};

export const INSURANCETYPE = [
  { key: 0, value: '', text: '' },
  { key: 1, value: 'HMO', text: 'HMO' },
  { key: 2, value: 'PPO', text: 'PPO' },
  { key: 3, value: 'MEDICAID', text: 'MEDICAID' },
  { key: 1, value: 'International Health Insurance', text: 'International Health Insurance' },
  { key: 2, value: 'Embassy', text: 'Embassy' },
  { key: 3, value: 'Self Pay', text: 'Self Pay' },
  { key: 6, value: 'OTHER', text: 'Other' }
];

export const RELATIONSHIP = [
  { key: 0, value: '', text: '' },
  { key: 1, value: 'Mother', text: 'I am mother' },
  { key: 2, value: 'Father', text: 'I am father' },
  { key: 3, value: 'Grandmother', text: 'I am grandmother' },
  { key: 1, value: 'Grandfather', text: 'I am grandfather' },
  { key: 2, value: 'Foster mother', text: 'I am foster mother' },
  { key: 3, value: 'Fosther father', text: 'I am fosther father' },
  { key: 6, value: 'OTHER', text: 'Other' }
];
